import React from "react"
import PropTypes from "prop-types"
import MasterElement from "./masterElement"
import dictionary from "../../utils/dictionary"
import { useSelector } from "react-redux"
import SimpleVirtualList from "../ui/simpleVirtualList"

const MastersList = ({ items, hasMore, onLoadMore }) => {
  const selectedLanguage = useSelector((state) => state.lang.lang)

  if (!items?.length) {
    return (
      <div className="text-darkBrown pt-[32px]">
        {dictionary[selectedLanguage].noData}
      </div>
    )
  }

  return (
    <div className="text-darkBrown pt-[32px]">
      <div className="grid grid-cols-5 bg-lightGray border border-gray rounded-t-lg  font-bold">
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].userName}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].expShort}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].position}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].rating}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].record}
        </div>
      </div>
      <SimpleVirtualList
        items={items}
        maxHeight={window.innerHeight - 320}
        rowHeight={52}
        renderRow={({ user, lastEl }) => (
          <MasterElement user={user} lastEl={lastEl} />
        )}
        footer={
          hasMore ? (
            <button
              type="button"
              className="text-brown underline text-sm hover:opacity-80"
              onClick={onLoadMore}
            >
              …
            </button>
          ) : null
        }
      />
    </div>
  )
}

MastersList.propTypes = {
  items: PropTypes.array,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
}

export default MastersList
